export const CUSTOM_HEADERS = {
  API_KEY: 'x-api-key',
  USER_INITIALIZED: 'x-user-initialized',
  USER_ACTIVE_ROLE: 'x-active-role',
  CACHE_OVERRIDE: 'x-cache-override',
};
